import React, {useEffect, useState, useRef} from "react";
import styled from "styled-components";
import {useChatDispatch} from "./store";
import {getChatIdentifier} from "../Auth";
import {audio} from "./AppChat";
import {showErrorToast} from "../Utilities";
import {setUnreadCountConversation} from "./utils";

const Notification = styled.div`
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 50%;
    text-align: center;
    background-color: ${props => (props.bgColor ? props.bgColor : "#d94c53")};
    font-size: 10px;
    color: white;
    cursor: pointer;
`;

type Props = {
    conversation: any;
};

const ChannelBadge: React.FC<Props> = (props) => {
    const {conversation} = props;
    // @ts-ignore
    const [notifications, setNotifications] = useState<number>(0);
    // @ts-ignore
    const dispatch = useChatDispatch();
    // @ts-ignore
    let currentIdentity = getChatIdentifier();
    const mounted = useRef(false);
    // console.log(`Render ChannelBadge ${channel?.friendlyName} ${JSON.stringify({notifications, mounted})}`);
    useEffect(() => {
        const abortController = new AbortController();
        // @ts-ignore
        let elem;
        // @ts-ignore
        let t1, t2, t3;
        if (conversation) {
            conversation.on("messageRemoved", async () => {
                try {
                    t3 = setTimeout(async () => {
                        await setUnreadCountConversation({
                            conversation: conversation,
                            setNotifications,
                            chatDispatch: dispatch,
                            type: 'SET_NOTIFICATIONS'
                        });
                    }, 400);
                } catch (e) {
                    await showErrorToast(e, 'Error in updating badge for workplace_bot.');
                }
            });
            conversation.on("messageAdded", async (message) => {
                try {
                    console.log({messageAdded: message});
                    elem = document.querySelector(`[data-id='container-${conversation.sid}']`);
                    console.log({
                        messageAdded: message,
                        author: message.author,
                        currentIdentity,
                        elem,
                        attributes: message.conversation.attributes,
                        // @ts-ignore
                        kind: message.conversation.attributes['kind'],
                        // @ts-ignore
                        test1: message.author === 'system' && message.conversation.attributes['kind'] === 'Bot',
                        test2: message.author !== currentIdentity && !elem,
                    });
                    // @ts-ignore
                    if (message.conversation.attributes['kind'] === 'Bot') {
                        t2 = setTimeout(async () => {
                            let n = await setUnreadCountConversation({
                                conversation: conversation,
                                setNotifications,
                                chatDispatch: dispatch,
                                type: 'SET_NOTIFICATIONS'
                            });
                            if (n !== 0) {
                                // @ts-ignore
                                audio.play().catch(error => console.log("Error in play()", {error}));
                            }
                        }, 500);
                    } else if (message.author !== currentIdentity && !elem) {
                        t2 = setTimeout(async () => {
                            let n = await setUnreadCountConversation({
                                conversation: conversation,
                                setNotifications,
                                chatDispatch: dispatch,
                                type: 'SET_NOTIFICATIONS'
                            });
                            if (n !== 0) {
                                // @ts-ignore
                                audio.play().catch(error => console.log("Error in play()", {error}));
                            }
                        }, 750);
                    }
                    dispatch({type: "MESSAGE_ADDED_ACTIVE_CONVERSATION", conversation: message.conversation});
                } catch (e) {
                    await showErrorToast(e, 'Error updating badge.');
                }
            });
            conversation.on("updated", async (event) => {
                try {
                    let elem = document.querySelector(`[data-id='container-${conversation.sid}']`);
                    if (elem) {
                        return;
                    }
                    // @ts-ignore
                    if (event.conversation && event.conversation.attributes["kind"] !== 'Bot' && Array.isArray(event.updateReasons)) {
                        let reasons = event.updateReasons;
                        if (reasons.includes('lastReadMessageIndex')) {
                            t1 = setTimeout(async () => {
                                await setUnreadCountConversation({
                                    conversation: conversation,
                                    setNotifications,
                                    chatDispatch: dispatch,
                                    type: 'SET_NOTIFICATIONS'
                                });
                            }, 750);
                        }
                    }
                } catch (e) {
                    await showErrorToast(e, 'Error updating badge in last message.');
                }
            });
            if (mounted.current) return;
            setUnreadCountConversation({
                conversation: conversation,
                setNotifications,
                chatDispatch: dispatch,
                type: 'INIT_NOTIFICATIONS'
            }).then((result) => {
                mounted.current = true;
                setNotifications(result);
            });
        }
        return () => {
            // clearInterval(t1);
            // clearInterval(t2);
            // clearInterval(t3);
            abortController.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (notifications > 0) {
        return (<Notification>{notifications}</Notification>);
    }

    if (notifications < 0) {
        return (<Notification>{notifications}</Notification>);
    }

    return (<Notification bgColor={'transparent'}/>);
}

function propsAreEqual(prev, next) {
    return prev.conversation.sid === next.conversation.sid;
}

const MemoizedChannelBadge = React.memo(ChannelBadge, propsAreEqual);

export default MemoizedChannelBadge;
